import axios from 'axios';

export const getPageSettingsData = () => {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'];
  const path = 'settings';
  return axios.get(`${baseUrl}/${path}`)
    .then((response) => response.data)
    .catch((error) => { throw new Error(`API ERROR in ${path} ===>`, error); });
};

export default getPageSettingsData;